module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/feature02-42c04abf8f5ed8023269f6f4416b058c.svg";